"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8703 7.844c-.588-.56-1.526-.84-2.814-.84h-3.192v9.9959h2.114v-3.556h.91c.9706 0 1.736-.154 2.296-.462.5693-.308.9753-.714 1.218-1.218.2426-.5133.364-1.0593.364-1.638 0-.9707-.2987-1.7313-.896-2.282zm-3.892.896h.966c1.12 0 1.68.4852 1.68 1.4559 0 .532-.1774.9193-.532 1.162-.3454.2333-.8167.35-1.414.35h-.7v-2.968z"
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 2H2v20h20V2zM4 20V4h16v16H4z"
  })];
};

exports.default = _default;